export default {  
    dadosColaborador:{
        DOCUMENTO: [
            { "CL": "RUT" },
            { "BR": "CPF" },
            { "CO": "DOC.ID.COL" },
            { "MX": "DOC.ID.MEX" },
            { "US": "DOC.ID.USA" },
            { "AR": "DOC.ID.ARG" },
            { "CR": "DOC.ID.CRI" },
            { "PA": "DOC.ID.PAN" },
            { "UY": "DOC.ID.URY" },
            { "PE": "DOC.ID.PER" },
            { "EC": "DOC.ID.ECU" }
        ],
        PRIMEIRO_NOME: "PRIM.NOME",
        NOME_MEIO: "NOME.MEIO",
        ULTIMO_NOME: "ULT.NOME",           
    },
    informacoesVaga:{
        APPLICATION_ID: "SF.APPL.ID",
        REQUISITION_ID: "SF.REQ.ID",
        CANDIDATE_ID: "SF.CAND.ID",
        TEMPLATE_ID: "SF.TMPL.ID",
        MOD_CONTR: "MOD.CONTR",
        ID_GERENTE_CONTRATANTE: "GER.CON.ID",
        NOME_GERENTE_CONTRATANTE: "GER.CON.NM",
        EMAIL_GERENTE_CONTRATANTE: "GER.CON.EM",
        NOME_PADRINHO: "PADRINHO",
        EMAIL_PADRINHO: "EMAIL.PAD",            
    },
    posicaoFisica:{
        NECESSITA_POSICAO_FISICA: "NEC.POSFIS",
        PREDIO: [
            { "CL": "PREDIO.CL" },
            { "CO": "PREDIO.CO" },
            { "MX": "PREDIO.MX" },
            { "US": "PREDIO.US" },
            { "AR": "PREDIO.AR" },
            { "CR": "PREDIO.CR" },
            { "PA": "PREDIO.PA" },
            { "UY": "PREDIO.UR" },
            { "PE": "PREDIO.PE" },
            { "EC": "PREDIO.EC" }
        ],
        BLOCO: "BLOCO",
        ANDAR: "ANDAR",
        NUM_POSICAO_FISICA: "NUM.POSFIS",
        SALA_GERENTE: "SALA.GER",
        NECESSITA_CELULAR: [
            { "CL": "NEC.CEL" },
            { "BR": "NEC.CEL" },
            { "CO": "NEC.CEL" },
            { "MX": "NEC.CEL" },
            { "US": "NEC.CEL" },
            { "AR": "NEC.CEL" },
            { "CR": "NEC.CEL" },
            { "PA": "NEC.CEL" },
            { "UY": "NEC.CEL" },
            { "PE": "NEC.CEL.PE" },
            { "EC": "NEC.CEL" }                 
        ],
        MODELO_CELULAR: "MODEL.CEL",
        OPERADORA: "OPERADOR",
        NECESSITA_RAMAL_TELEFONICO: [
            { "CL": "NEC.RAM.CL" },
            { "BR": "NEC.RAM.BR" },
            { "CO": "NEC.RAM.CO" },
            { "MX": "NEC.RAM.MX" },
            { "US": "NEC.RAM.US" },
            { "AR": "NEC.RAM.AR" },
            { "CR": "NEC.RAM.CR" },
            { "PA": "NEC.RAM.PA" },
            { "UY": "NEC.RAM.UR" },
            { "PE": "NEC.RAM.PE" },
            { "EC": "NEC.RAM.EC" }
        ]            
    },
    premissas:{
        EQUIPAMENTO: [
            { "CL": "NEC.EQU.CL" },
            { "CO": "NEC.EQU.CO" },
            { "BR": "NEC.EQU.BR" },
            { "MX": "NEC.EQU.MX" },
            { "US": "NEC.EQU.US" },
            { "AR": "NEC.EQU.AR" },
            { "CR": "NEC.EQU.CR" },
            { "PA": "NEC.EQU.PA" },
            { "UY": "NEC.EQU.UR" },
            { "PE": "NEC.EQU.PE" },
            { "EC": "NEC.EQU.EC" },
        ],
        INTERNET_PROTOCOL: "IP",
        NECESSITA_EMAIL: "NEC.EMAIL",
        OBSERVACOES: "OBS"
    },
}